import {NgModule} from '@angular/core';

import {MiniButtonsComponent} from './mini-buttons.component';

@NgModule({
  declarations: [MiniButtonsComponent],
  exports: [MiniButtonsComponent],
})
export class MiniButtonsModule {}
